import { render, staticRenderFns } from "./truncate.vue?vue&type=template&id=744a4960&"
import script from "./truncate.vue?vue&type=script&lang=js&"
export * from "./truncate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports